// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"op-z","badgeLink":"pp-z","category":"qp-z"};